import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_LEGAL_CARGOS,
  FLAG_GETTING_LEGAL_CARGOS,
  GET_LEGAL_CARGOS,
} from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { LEGAL_PARCEL_ENDPOINT } from '../../config/endpoints';

const flagGettingLegalCargos = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LEGAL_CARGOS,
    payload: flag,
  });

const clearLegalCargos = () => (dispatch) =>
  dispatch({
    type: CLEAR_LEGAL_CARGOS,
  });

const getLegalCargos = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingLegalCargos(true));
    const query = tableFilters;
    const url = `${LEGAL_PARCEL_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const cargos = await response.json();
    dispatch({
      type: GET_LEGAL_CARGOS,
      payload: cargos,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingLegalCargos(false));
  }
};

const getLegalCargosByDocumentNumber = async ({ documentSerie, documentCode }) => async (dispatch) => {
  try {
    dispatch(flagGettingLegalCargos(true));
    const query = QueryString.stringify({
      documentSerie,
      documentCode,
    });
    const url = `${LEGAL_PARCEL_ENDPOINT}/document-number?${query}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const cargos = await response.json();
    dispatch({
      type: GET_LEGAL_CARGOS,
      payload: cargos,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingLegalCargos(false));
  }
};

const postGenerateExcel =
  async (items) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingLegalCargos(true));
        const url = `${LEGAL_PARCEL_ENDPOINT}/actions/export-excel`;
        const response = await fetch(url, { ...DEFAULT_POST_CONFIG, body: JSON.stringify(items) });
        await isErrorResponse(response);
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = "CARGA";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagGettingLegalCargos(false));
      }
    };

export { flagGettingLegalCargos, getLegalCargos, clearLegalCargos, postGenerateExcel, getLegalCargosByDocumentNumber };
